<template>
  <div>
    <div class="title-top-alarm">
      <div><span>{{quickObj.quickTitle}}</span></div>
      <div class="line-title"></div>
    </div>
    <div v-loading="loading">
      <div style="min-height: 200px">
        <div style="margin: 10px 20px 0">
          <div v-if="quickObj.isQuick" style="height: 40px;font-size: 16px;">
            <el-row>
              <el-col :span="6">
                <span>组织</span>
                <el-cascader v-fixZoom class="my-form-inpt" size="mini" style="width: 230px" :options="orgOptions" v-model="selectorgid" :filterable="true" placeholder="请选择组织"
                  :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                  ref="orgOptions" @change="selectOrgId">
                </el-cascader>
              </el-col>
              <el-col :span="6">
                <span>{{ labelCommunity }}</span>
                <el-select v-fixZoom class="my-form-inpt" size="mini" v-model="cid" filterable :placeholder="`请选择` + labelCommunity" style="width: 210px" @change="selectCommunityID">
                  <el-option v-for="item in orgcommunitys" :key="item.value" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="6">
                <span>{{ labelHome }}</span>
                <el-select v-fixZoom class="my-form-inpt" size="mini" style="width: 210px" filterable v-model="hid" :placeholder="`请选择` + labelHome" @change="selectHomeID">
                  <el-option v-for="item in selectorghomes" :key="item.id" :label="item.address" :value="item.id">
                    <span style="">{{ item.address }}</span>&nbsp;
                    <span style="color: #8492a6; font-size: 12px">{{ item.telephone }}</span>
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="6">
                <span>服务对象</span>
                <el-select v-fixZoom class="my-form-inpt" size="mini" style="width: 200px;" filterable v-model="pid" placeholder="请选择所属人员" @change="selectPerson">
                  <el-option v-for="item in selectoldpersons" :key="item.index" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </div>
        <div style="margin: 0 40px;height: 65px"> <!--tab栏-->
          <div class="line-tab">
            <div :class="item.index === indexActive ? 'select-active1' : 'no-select1'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
              <span v-if="item.index === 0 && isAddPerson">{{item.name2}}</span>
              <span v-else>{{item.name1}}</span>
            </div>
<!--            <div v-if="quickObj.isQuick" style="padding-top: 13px">-->
<!--              <div v-if="indexActive === 0 && !isAddPerson" class="add-open-btn" @click="addOpen()">-->
<!--                <strong>+</strong>-->
<!--              </div>-->
<!--            </div>-->
            <div style="margin-top: 13px" v-if="indexActive !== 9 && indexActive !== 7 && indexActive !== 6 && indexActive !== 5 && indexActive !== 4 && indexActive !== 3 && indexActive !== 0 && !isAddPerson" class="add-open-btn" @click="addOpen()">
              <strong>+</strong>
            </div>
          </div>
        </div>
        <div v-if="indexActive === 0">
          <old-person v-if="!loading" ref="oldPerson" :personObj="personObj" @getFather="getFather"></old-person>
        </div>
        <!--    设备详情    -->
        <div style="margin:0 40px;" v-if="indexActive === 1">
          <device-details :deviceObj="deviceObj"></device-details>
        </div>
        <!--    联系人信息    -->
        <div style="margin:10px 40px 0;" v-if="indexActive === 2">
          <family-contact :familyObj="familyObj" @getFatherOpen="getFatherOpen"></family-contact>
        </div>
        <!--    服务日志    -->
        <div style="margin:0 40px;" v-if="indexActive === 3">
          <history-log :logObj="logObj"></history-log>
        </div>
        <!--    家庭信息    -->
        <div style="margin:0 40px;" v-if="indexActive === 4">
          <relation-edit :relationEditRow="relationEditRow"></relation-edit>
        </div>
        <!--    老人病史    -->
        <div v-if="indexActive === 5">
          <old-person-disease :diseaseObj="servicelistObjAll" @changeEndDisease="changeEndBasic"></old-person-disease>
        </div>
        <!--    经济情况    -->
        <div v-if="indexActive === 6">
          <economic-situation :economicObj="servicelistObjAll" @changeEndEconomic="changeEndBasic"></economic-situation>
        </div>
        <!--    备注信息    -->
        <div v-if="indexActive === 7">
          <note-info :noteObj="servicelistObjAll" @changeEndNote="changeEndBasic"></note-info>
        </div>
        <!--    电子归档    -->
        <div style="margin:0 20px;" v-if="indexActive === 9">
          <old-person-file :infoRow="servicelistObjAll" @changeEnd="changeEndBasic"></old-person-file>
        </div>
      </div>
    </div>
    <!--绑定设备-->
    <el-dialog width="650px" :show-close="false" :visible.sync="addShow" v-if="addShow" :close-on-click-modal="false" center append-to-body class="all-open">
      <div class="title-top-alarm">
        <div><span>绑定设备</span></div>
        <div class="line-title"></div>
      </div>
      <device-add :addDeviceRow="addRow" v-model="addShow"  @getFatherDevice="getFatherDevice"></device-add>
    </el-dialog>
    <!--添加联系人-->
    <el-dialog width="650px" :visible.sync="addContactShow" v-if="addContactShow" center append-to-body class="all-open">
      <div class="title-top-alarm">
        <div><span>{{ centactTitle }}</span></div>
        <div class="line-title"></div>
      </div>
      <add-contact :contactObj="contactObj" v-model="addContactShow"></add-contact>
    </el-dialog>
  </div>
</template>

<script>
import oldPerson from './components/oldPerson'
import deviceDetails from './components/deviceDetails'
import familyContact from './components/familyContact'
import deviceAdd from '../childComponents/deviceAdd'
import addContact from '../childComponents/addContact'
import historyLog from './components/historyLog'
import relationEdit from '../childComponents/relationEdit'

import oldPersonDisease from '../../oldPersonHome/components/oldPersonDisease'
import economicSituation from '../../oldPersonHome/components/economicSituation'
import noteInfo from '../../oldPersonHome/components/noteInfo'
import oldPersonFile from '../../oldPersonHome/components/oldPersonFile'
import {queryfrequency, queryproject, updateoldperson} from '../../../api/serviceObject'
import {queryorg, querycommunitybyorgids} from '../../../api/organizer'
import {queryhomebycids} from '../../../api/relation'
import {queryoldpersonbyhids, queryhomebyhids} from '../../../api/handlealarm'
import {queryorgcommunity} from '../../../api/community'
export default {
  name: 'quickOpen',
  components: {oldPerson, deviceDetails, familyContact, deviceAdd, addContact, historyLog, relationEdit, oldPersonDisease, economicSituation, noteInfo, oldPersonFile},
  model: {
    prop: 'quickShow',
    event: 'change'
  },
  props: {
    quickObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      oldPersonRow: '',
      labelCommunity: '',
      labelHome: '',
      // orgid: '',
      loading: true,
      fok: false,
      pjok: false,
      // 组织
      orgok: false,
      orgData: [],
      selectorgid: '',
      orgOptions: [],
      // 小区
      cok: false,
      allorgcommunitys: [],
      orgcommunitys: [],
      cid: '',
      // 家庭/机构
      ook: false,
      orghomes: [],
      selectorghomes: [],
      hid: '',
      // 服务对象
      pok: false,
      oldpersons: [],
      selectoldpersons: [],
      pid: '',
      selectCH: {
        orgcommunitys: [],
        cid: '',
        selectorghomes: [],
        hid: ''
      },
      tabs: [
        {index: 0, name1: '编辑成员', name2: '添加成员'},
        {index: 1, name1: '设备详情', name2: ''},
        {index: 2, name1: '联系人信息', name2: ''}
      ],
      indexActive: '',
      // 服务对象
      isAddPerson: true,
      personObj: {
        orgcommunitys: [],
        orgOptions: [],
        frequencys: [],
        projects: [],
        isAddPerson: true, // 是否是新建服务对象或编辑
        isDoAdd: false, // 完成新建服务对象之后再修改
        editRow: {}, // 编辑人信息
        addData: {} // 添加完成之后的表单信息
      },
      backData: '',
      // 绑定设备
      deviceObj: {
        personId: '',
        hid: ''
      },
      addShow: false,
      addRow: {
        orgTree: [],
        orgcommunitys: [],
        orghomes: [],
        oldpersons: [],
        home: '',
        isGateway: false,
        row: '', // 人信息
        orgids: [],
        isAddPerson: false // 是否添加人绑定设备
      },
      // 联系人
      familyObj: {
        personId: '',
        hid: ''
      },
      centactTitle: '',
      addContactShow: false,
      contactObj: {
        isAdd: true,
        personRow: '',
        contactRow: ''
      },
      // 服务日志
      logObj: {
        isFive: false,
        personids: []
      },
      // 编辑家庭固话
      relationEditRow: {
        isQuick: true,
        orgcommunitys: [],
        row: {},
        orgTree: []
      },
      moduletag: '',
      servicelistObjAll: {
        oldPersonRow: '',
        isJuJia: true
      }
    }
  },
  created () {
    /* 1、快捷操作 按钮 2、服务对象管理 serviceObject.vue */
    // this.orgid = this.$store.state.user.orgid
    this.moduletag = this.$store.state.user.moduletag
    this.oldPersonRow = this.quickObj.oldPersonRow
    this.getModuleTag()
    this.getAllCommunity()
    if (this.quickObj.isQuick) {
      this.getOrgData()
      this.getFrequency()
      this.getProjects()
    } else {
      this.getDataList()
    }
  },
  methods: {
    getModuleTag () {
      if (this.moduletag === 1) {
        this.labelCommunity = '小区'
        this.labelHome = '家庭'
      } else if (this.moduletag === 2) {
        this.labelCommunity = '机构'
        this.labelHome = '房间'
      } else { // 0
        this.labelCommunity = '小区/机构'
        this.labelHome = '家庭/房间'
      }
    },
    getDataList () {
      // 组织
      this.orgOptions = this.quickObj.orgOptions
      this.relationEditRow.orgTree = this.orgOptions
      this.personObj.orgOptions = this.orgOptions
      this.orgok = true
      // 查询频率
      this.personObj.frequencys = this.quickObj.frequencys
      this.fok = true
      // 查询项目
      this.personObj.projects = this.quickObj.projects
      this.pjok = true
      // end
      this.isAddPerson = this.quickObj.isAdd
      this.personObj.isAddPerson = this.isAddPerson
      if (!this.isAddPerson) { // 表格编辑
        this.tabs = [
          {index: 0, name1: '编辑成员', name2: '添加成员'},
          {index: 1, name1: '设备详情', name2: ''},
          {index: 2, name1: '联系人信息', name2: ''},
          {index: 3, name1: '服务日志', name2: ''},
          {index: 4, name1: '家庭信息', name2: ''},
          {index: 5, name1: '老人病史', name2: ''},
          {index: 6, name1: '经济情况', name2: ''},
          {index: 7, name1: '备注信息', name2: ''}
          // {index: 9, name1: '电子归档', name2: ''}
        ]
        this.personObj.editRow = this.oldPersonRow
        this.deviceObj.personId = this.oldPersonRow.id
        this.deviceObj.hid = this.oldPersonRow.homeid
        this.familyObj.personId = this.oldPersonRow.id
        this.familyObj.hid = this.oldPersonRow.homeid
        this.contactObj.personRow = this.oldPersonRow
        this.addRow.row = this.oldPersonRow
        this.logObj.personids = [this.oldPersonRow.id]
        this.getHomeData(this.oldPersonRow.homeid)
        this.servicelistObjAll.oldPersonRow = this.oldPersonRow
      } else {
        this.tabs = [
          {index: 0, name1: '', name2: '添加成员'},
          {index: 1, name1: '设备详情', name2: ''},
          {index: 2, name1: '联系人信息', name2: ''}
        ]
      }
    },
    // 家信息
    getHomeData (homeid) {
      let data = {
        hids: [homeid]
      }
      queryhomebyhids(data).then(res => {
        this.homes = res.data.homes
        if (res.data.homes.length > 0) {
          this.relationEditRow.row = res.data.homes[0]
        }
      }).catch(() => {})
    },
    // 所有小区/机构
    getAllCommunity () {
      this.loading = true
      queryorgcommunity().then(res => {
        this.cok = true
        this.orgcommunitys = res.data.orgcommunitys
        this.allorgcommunitys = res.data.orgcommunitys
        this.personObj.orgcommunitys = res.data.orgcommunitys
        this.relationEditRow.orgcommunitys = this.personObj.orgcommunitys
        this.getIsOk()
      }).catch(() => {})
    },
    // 组织
    getOrgData () {
      queryorg().then(res => {
        this.orgok = true
        this.getIsOk()
        this.addRow.orgTree = this.clone(res.data.org)
        this.orgData = res.data.org
        // 所属组织
        let lastLevel = 100
        const arr = res.data.org
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level < lastLevel) {
            lastLevel = arr[i].level
          }
        }
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level === lastLevel) {
            this.orgOptions.push(arr[i])
          }
        }
        for (let i = 0; i < this.orgOptions.length; i++) {
          const child = this.arrayToNode(arr, this.orgOptions[i].id)
          if (child.length !== 0) {
            this.orgOptions[i].child = child
          }
        }
        this.relationEditRow.orgTree = this.orgOptions
        this.personObj.orgOptions = this.orgOptions
        this.$refs.oldPerson.getParentOrgData(this.orgOptions)
      }).catch(() => {})
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    // 查询频率
    getFrequency () {
      this.loading = true
      let data = {
        orgid: this.$store.state.user.orgid
      }
      queryfrequency(data).then(res => {
        this.personObj.frequencys = res.data.frequencys
        this.fok = true
        this.getIsOk()
      }).catch(() => {
        this.loading = false
      })
    },
    // 查询项目
    getProjects () {
      let data = {
        orgid: this.$store.state.user.orgid
      }
      queryproject(data).then(res => {
        this.personObj.projects = res.data.projects
        this.pjok = true
        this.getIsOk()
      }).catch(() => {
        this.loading = false
      })
    },
    getIsOk () {
      // console.log(this.orgok, this.fok, this.pjok, this.cok)
      if (this.orgok && this.fok && this.pjok && this.cok) {
        this.indexActive = 0
        this.loading = false
      }
    },
    selectOrgId (id) {
      this.cid = ''
      this.hid = ''
      this.pid = ''
      // 小区选择
      this.selectCH.selectorghomes = ''
      this.selectCH.cid = ''
      // 家选择
      this.selectCH.hid = ''
      let data = {
        orgids: [id]
      }
      querycommunitybyorgids(data).then(res => {
        this.orgcommunitys = res.data.communitys
        this.selectCH.orgcommunitys = this.orgcommunitys
        this.$refs.oldPerson.getOrgSelectHome(this.orgcommunitys)
      }).catch(() => {})
    },
    selectCommunityID (id) {
      this.hid = ''
      this.pid = ''
      // 家选择
      this.selectCH.hid = ''
      let data = {
        cids: [id]
      }
      queryhomebycids(data).then(res => {
        this.selectorghomes = res.data.homes
        this.selectCH.selectorghomes = this.selectorghomes
        this.selectCH.cid = id
      }).catch(() => {})
    },
    selectHomeID (id) {
      this.pid = ''
      let data = {
        hids: [id]
      }
      queryoldpersonbyhids(data).then(res => {
        this.selectoldpersons = res.data.persons
        this.selectCH.hid = id
      }).catch(() => {})
    },
    selectPerson (id) {
      this.isAddPerson = false
      this.tabs = [
        {index: 0, name1: '编辑成员', name2: ''},
        {index: 1, name1: '设备详情', name2: ''},
        {index: 2, name1: '联系人信息', name2: ''},
        {index: 3, name1: '服务日志', name2: ''},
        {index: 4, name1: '家庭信息', name2: ''}
      ]
      let obj = ''
      for (let i = 0; i < this.selectoldpersons.length; i++) {
        if (id === this.selectoldpersons[i].id) {
          obj = this.selectoldpersons[i]
        }
      }
      // this.personId = id
      this.deviceObj.personId = id
      this.deviceObj.hid = obj.homeid
      this.contactObj.personRow = obj
      this.familyObj.personId = id
      this.familyObj.hid = obj.homeid
      this.logObj.personids = [id]
      // this.$refs.oldPerson.getParentCHData(this.selectCH)
      this.$refs.oldPerson.selectOldPerson(obj, this.isAddPerson)
      this.personObj.editRow = obj
      this.personObj.isAddPerson = false
      this.addRow.row = obj
      for (let i = 0; i < this.selectorghomes.length; i++) {
        if (obj.homeid === this.selectorghomes[i].id) {
          this.relationEditRow.row = this.selectorghomes[i]
          this.addRow.home = this.selectorghomes[i]
        }
      }
    },
    selectTab (item) {
      this.indexActive = item.index
    },
    addOpen () {
      if (this.indexActive === 0) {
        this.isAddPerson = true
        this.tabs = [
          {index: 0, name1: '', name2: '添加成员'},
          {index: 1, name1: '设备详情', name2: ''},
          {index: 2, name1: '联系人信息', name2: ''}
        ]
        this.$refs.oldPerson.selectAdd()
      } else if (this.indexActive === 1) {
        console.log(this.addRow)
        this.addRow.isAddPerson = false
        this.addShow = true
      } else if (this.indexActive === 2) {
        this.centactTitle = '添加联系人'
        this.contactObj.isAdd = true
        this.contactObj.contactRow = ''
        this.addContactShow = true
      }
    },
    getFatherOpen (obj) {
      this.centactTitle = '更新联系人'
      this.contactObj.isAdd = false
      this.contactObj.contactRow = obj
      this.addContactShow = true
    },
    // 组件人调用
    getFather (obj) {
      // console.log(obj)
      if (obj.type === 'close') {
        this.$emit('change', false)
      }
      if (obj.type === 'isAddHome') { // 新建家庭返回的数据
        if (this.cid === obj.cid) {
          this.selectorghomes.push(obj.home)
        }
      } else if (obj.type === 'isEdit') {
        // 编辑点击弹窗初始获取家信息
        this.addRow.home = obj.home
      } else if (obj.type === 'bind') { // 绑定设备
        console.log('bind', obj)
        this.addRow.row = obj.oldPerson
        this.addRow.isAddPerson = true
        this.addShow = true
        this.personObj.editRow = obj.oldPerson
        this.personObj.isAddPerson = false
      }
    },
    getFatherDevice (obj) {
      if (obj.type === 'addOldPerson') {
        this.addShow = false // 关闭添加设备弹窗
        this.$emit('change', false) // 关闭快捷弹窗
      }
    },
    changeEndBasic (obj) {
      console.log(obj)
      if (obj.type) {
        this.$emit('change', false) // 关闭快捷弹窗
        return
      }
      let data = this.clone(this.oldPersonRow)
      data.extra_info = obj
      updateoldperson(data).then(res => {
        this.$notify({ title: '成功', message: '成功保存信息', type: 'success', duration: 2000 })
        if (this.$route.path === '/serviceObject') {
          this.golobleObject.updateTableSerObj()
        }
        this.oldPersonRow.extra_info = obj
        this.getDataList()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/quick/quickOpen.vue